<table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="row-border hover">
  <thead>
    <tr>
      <th *ngFor="let i of getVisibleColumns()" [attr.data-column]="i">
        {{ getColumnTitle(i) }}
      </th>
      <th></th> <!-- Actions column header -->
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let process of processes">
      <td *ngFor="let attr of getVisibleAttributes(process)">
        <span style="background-color: transparent; color: inherit; padding: 2px; border-radius: 5px">
          {{ attr.value }}
        </span>
      </td>
      <td>
        <div style="display: flex; gap: 2px; align-items: center">
          <ng-container *ngFor="let action of process.actions">
            <button *ngIf="isHistoryAction(action)" 
                    class="btn btn-outline-primary btn-sm" 
                    style="border: none; padding: 2px" 
                    (click)="openCustomModal(action, process)">
              <i class="fa fa-history" style="font-size: 1.5em; color: #007bff;"></i>
            </button>

            <a *ngIf="isLinkAction(action) && getStatus(process) !== 'Em Cartório'" 
               [href]="getActionOption(action, 'urlLink')" 
               [target]="getActionOption(action, 'buttonTarget')" 
               class="btn btn-outline-primary btn-sm"
               style="border: none; padding: 2px">
              <i class="fa" [ngClass]="'fa fa-' + getActionOption(action, 'icon')" style="font-size: 1.5em; color: #007bff;"></i>
            </a>

            <button *ngIf="isModalAction(action) && getStatus(process) !== 'Liquidado' && getStatus(process) !== 'Em Cartório'" 
                class="btn btn-outline-primary btn-sm" 
                style="border: none; padding: 2px" 
                (click)="openCustomModal(action, process)">
              <i class="fa" [ngClass]="'fa fa-' + getActionOption(action, 'icon')" style="font-size: 1.5em; color: #007bff;"></i>
            </button>
          </ng-container>
        </div>
      </td>
    </tr>
  </tbody>
</table>
<app-prorrogacao
  *ngIf="isModalOpen && modalTitle === 'Prorrogação' && modalData"
  [attributes]="modalData"
  (close)="closeModal()"
></app-prorrogacao>
<app-baixa
  *ngIf="isModalOpen && modalTitle === 'Baixa' && modalData"
  [attributes]="modalData"
  (close)="closeModal()"
></app-baixa>
<app-abatimento
  *ngIf="isModalOpen && modalTitle === 'Abatimento' && modalData"
  [attributes]="modalData"
  (close)="closeModal()"
></app-abatimento>
<app-history
  *ngIf="isModalOpen && modalTitle === 'Histórico' && modalData"
  [history]="modalData.history"
  [documento]="modalData.documento"
  (close)="closeModal()"
></app-history>
<script>
  moment.locale('pt-br');
</script>